export enum ModalSize {
    LARGE = 'lg',
    XLARGE = 'xlg',
    FULL = 'full'
}
